import React from 'react';
import PT from 'prop-types';
import _ from 'lodash';

class Tree extends React.Component {
  state = {
    treeBeard: {},
  };

  static propTypes = {
    name: PT.string.isRequired,
    dataSource: PT.arrayOf(PT.shape({
      title: PT.string,
      description: PT.string
    }))
  }

  static defaultProps = {
    dataSource: []
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (!_.isEmpty(nextProps.dataSource) && _.isEmpty(prevState.treeBeard)) {
      return {
        treeBeard: _.map(nextProps.dataSource, his => ({
          ...his,
          toggle: false,
          height: 0
        }))
      };
    }
    return null;
  }

  componentDidUpdate = (prevProps, prevState) => {
    // const { dataSource } = prevProps;
    // console.log('componentDidUpdate prevProps', prevProps);
    // console.log('componentDidUpdate props', this.props);
    // const treeBeard = _.map(dataSource, his => ({
    //   ...his,
    //   toggle: false,
    //   height: 0
    // }));
    if (prevProps.language !== this.props.language) {
      const { dataSource } = this.props;
      const treeBeard = _.map(dataSource, his => ({
        ...his,
        toggle: false,
        height: 0
      }));
      this.setState({
        treeBeard
      });
    }
  }

  componentDidMount() {
    const { dataSource } = this.props;
    const treeBeard = _.map(dataSource, his => ({
      ...his,
      toggle: false,
      height: 0
    }));
    this.setState({
      treeBeard,
    });
  }

  handleExpand = (id, index) => {
    const { treeBeard } = this.state;
    const targetEl = document.querySelectorAll('.tree-content p');
    const height = _.get(targetEl, [index, 'offsetHeight']);
    treeBeard[index] = {
      ...treeBeard[index],
      toggle: !treeBeard[index].toggle,
      height: !treeBeard[index].toggle ? height + 30 : 0
    };

    this.setState({
      treeBeard: [...treeBeard]
    });
  };

  render() {
    const { treeBeard } = this.state;
    const { name } = this.props;
    return (
      <ul className="component-tree" id={name} >
        {_.map(treeBeard, (data, index) => {
          const open = _.get(data, 'toggle', false);
          return (
            <li
              aria-hidden
              key={`list-${index}`}
              className={`list ${open ? 'open' : ''}`}
            >
              <div className="line" />
              <div
                aria-hidden
                onClick={() => this.handleExpand(data.title, index)}
                id={data.title}
                className="treeNode"
              >
                <div className="icon" />
                <h3 className="text-year">{data.title}</h3>
              </div>
              <div
                id={`content-${index}`}
                className="block-detail"
              >
                <div
                  style={{ height: data.height }}
                  className={`tree-content whiteGray col-11 ${
                    open ? 'open' : ''
                  }`}
                  dangerouslySetInnerHTML={{
                    __html: data.description
                  }}
                />
              </div>
            </li>
          );
        })}
      </ul>
    );
  }
}

export default Tree;



// WEBPACK FOOTER //
// ./src/components/Tree.js